"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var report_html_1 = __importDefault(require("./report.html"));
require("./report.less");
require("@services/exports/page-context-manager");
(function (module) {
    'use strict';
    var PAGES_SELECTOR = '.pr-pages', 
    // the space between pages, not the actual margins on the page
    PAGE_MARGIN = 32, SCROLL_THROTTLE_MS = 100;
    ReportController.$inject = [
        '$compile',
        '$scope',
        '$timeout',
        'prFlowingPages',
        'prScrollService',
        'prViewOptions',
        'pr.pageContextManager'
    ];
    function ReportController($compile, $scope, $timeout, flowingPages, scrollService, viewOptions, pageContextManager) {
        var $ctrl = this, 
        // we keep track of our own active page so we know if we changed it,
        // or if it was changed from somewhere else (clicked on TOC), and we need to scroll
        activePage, pageCount = 0, range = [], 
        // Hack to get the element. I should probably be using a directive...
        $element = $(PAGES_SELECTOR);
        angular.extend($ctrl, {
            $onInit: function () {
                activePage = $ctrl.activePage;
                range = getRange();
                scrollService.onScroll(debouncedUpdateLoadedPages);
            },
            $doCheck: function () {
                var newCount = $ctrl.getPages().length;
                if (newCount !== pageCount) {
                    pageCount = newCount;
                    // give it a sec to kick in, then make sure our view window is big enough
                    $timeout(function () {
                        viewOptions.updateZoom();
                    });
                }
            },
            $onChanges: function (changes) {
                var ap = changes.activePage, vp = changes.visiblePages;
                if (ap && !ap.isFirstChange() || vp && !vp.isFirstChange()) {
                    // update the new visible range
                    range = getRange();
                    if ($ctrl.activePage !== activePage) {
                        activePage = $ctrl.activePage;
                        scrollToPage(activePage);
                    }
                }
            },
            isVisible: function (idx) {
                return idx >= range[0] && idx <= range[1] || ($ctrl.interactingPages || []).indexOf(idx) >= 0;
            },
            getPages: function () {
                return flowingPages.getPages();
            },
            getPageNumber: function (index) {
                return pageContextManager.getStartPageNumber() + index;
            }
        });
        function getRange() {
            var total = $ctrl.visiblePages, len = $ctrl.getPages().length, start = Math.max(Math.min($ctrl.activePage - 1, len - total), 0), end = start + total;
            return [start, end];
        }
        function getPageContainers() {
            return $element.children();
        }
        function scrollToPage(idx) {
            var pagesDom = getPageContainers();
            if (pagesDom.length <= idx) {
                return;
            }
            scrollService.scrollTo(pagesDom.eq(idx));
        }
        var debouncedUpdateLoadedPages = _.debounce(updateLoadedPages, SCROLL_THROTTLE_MS);
        function updateLoadedPages(evt, scrollPos) {
            var pageHeight = getPageHeight(), topIdx = Math.round(scrollPos / pageHeight);
            activePage = topIdx;
            $ctrl.bdyCtrl.setActivePage(topIdx);
            $ctrl.bdyCtrl.$digest();
        }
        function getPageHeight() {
            var pagesDom = getPageContainers();
            var zoomFactor = viewOptions.getZoomFactor();
            return (pagesDom.eq(0).height() + PAGE_MARGIN) * zoomFactor;
        }
    }
    module.component('prReport', {
        templateUrl: report_html_1.default,
        controller: ReportController,
        require: {
            bdyCtrl: '^prBody'
        },
        bindings: {
            activePage: '<',
            visiblePages: '<',
            interactingPages: '<'
        }
    });
}(angular.module('qualtrics.pr')));
